import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Creditcard = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M4 10.25H7V8.75H4V10.25Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M2.5 3H13.5C14.3284 3 15 3.67157 15 4.5V11.5C15 12.3284 14.3284 13 13.5 13H2.5C1.67157 13 1 12.3284 1 11.5V4.5C1 3.67157 1.67157 3 2.5 3ZM13.5 4.5H2.5V6.25H13.5V4.5ZM2.5 11.5L2.5 7.75H13.5V11.5H2.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Creditcard;
